<template>
    <div class="banner" :style="{ backgroundImage: `url(${list[0]})` }">
        <!--    <van-notice-bar
        left-icon="volume-o"
        text="八点秒得复购店开张啦!为响应广大消费者的呼声,从即日起开设八点秒得复购店,赶紧点击入店吧!小八在店里恭候各位客官老爷光临!"
        style="align-items: center"
        @click="goNewUrl"
    />-->
        <!--    <van-swipe>
      <van-swipe-item>
        <img :src="list[0]"/>
      </van-swipe-item>
    </van-swipe>-->
    </div>
</template>

<script>
export default {
    data() {
        return {
            // list: [require("@/assets/bg.jpg")],
            list: [require('@/assets/nbg.jpg')],
        }
    },
    methods: {
        goNewUrl() {
            window.location.href = 'http://prod-app-frontend.zhijianmedia.cn/south-taihu-store/#/?brandId=62'
        },
    },
}
</script>

<style lang="less" scoped>
.banner {
    width: 100%;
    // margin-top: 60px;
    margin-bottom: 10px;
    height: 156px;
    position: relative;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
}
</style>
